function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// applications
import { initializeValidateEventNavigator } from "Shared/ts/applications/form"; // components

import StatusScreen from "Shared/ts/components/status-screen";
export default class Form {
  set form(form) {
    Form.form.set(this, form);
  }

  get form() {
    return new Promise((resolve, reject) => {
      var value = Form.form.get(this);
      value ? resolve(value) : reject("Failed to get HTMLFormElement.");
    });
  }

  set submit(submit) {
    Form.submit.set(this, submit);
  }

  get submit() {
    return new Promise((resolve, reject) => {
      var value = Form.submit.get(this);
      value ? resolve(value) : reject("Failed to get HTMLButtonElement.");
    });
  }

  set parameters(parameters) {
    Form.parameters.set(this, parameters);
  }

  get parameters() {
    return new Promise((resolve, reject) => {
      var value = Form.parameters.get(this);
      value ? resolve(value) : reject("Failed to get parameters.");
    });
  }

  set statusScreen(statusScreen) {
    Form.statusScreen.set(this, statusScreen);
  }

  get statusScreen() {
    return new Promise((resolve, reject) => {
      var value = Form.statusScreen.get(this);
      value ? resolve(value) : reject("Failed to get status screen.");
    });
  }

  constructor(id) {
    this.form = document.querySelector("form#" + id);
    this.form.then(form => {
      this.submit = form.querySelector("[type=\"submit\"]");
    });
    this.initializeValidationRules();
    this.initializeStatusScreen();
  }

  initializeStatusScreen() {
    var _this = this;

    return _asyncToGenerator(function* () {
      _this.statusScreen = new StatusScreen();
    })();
  }

  initializeValidationRules() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var form = yield _this2.form;
      var submit = yield _this2.submit;
      yield initializeValidateEventNavigator(form, submit, parameters => {
        _this2.parameters = parameters;
      });

      _this2.handleNetworkTransaction();
    })();
  }

  handleNetworkTransaction() {
    return _asyncToGenerator(function* () {})();
  }

}
Form.form = new WeakMap();
Form.submit = new WeakMap();
Form.parameters = new WeakMap();
Form.statusScreen = new WeakMap();